import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Img } from "./ImageBlock";
import { defaultData } from "./ImgBlockDefaultData";
import { meta } from "./ImgBlockMetaData";

export const ImgBlock: BlockExport = {
  type: "component",
  Block: Img,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-image",
    size: 24,
  },
  defaultData,
  meta,
};
